export const documentUploadAccept = 'application/msword, text/plain, application/pdf, image/*';
